import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import jsonStorage from '../utils/json-storage';

const subjectIsFromThankYou = new BehaviorSubject(false);

export const questionnaireRedirectionLink = {
  subject: undefined,

  lazyInit() {
    if (questionnaireRedirectionLink.subject) return questionnaireRedirectionLink.subject;
    if (typeof window !== 'undefined') {
      const storage = window.localStorage;
      const redirectionLink = jsonStorage.get('questionnaireRedirectionLink', { storage }) || false;

      questionnaireRedirectionLink.subject = new BehaviorSubject(redirectionLink);
      return questionnaireRedirectionLink.subject;
    }
  },

  update: link => {
    const redirectionLinkSubject = questionnaireRedirectionLink.lazyInit();
    const storage = window.localStorage;
    jsonStorage.set('questionnaireRedirectionLink', link, { storage });
    redirectionLinkSubject.next(link);
  },
  getValue: () => {
    const redirectionLinkSubject = questionnaireRedirectionLink.lazyInit();
    return redirectionLinkSubject?.value;
  },
};

export const IsFromThankYouPage = {
  update: value => {
    subjectIsFromThankYou.next(value);
  },
  subscribe: setState => subjectIsFromThankYou.subscribe(setState),
  getValue: () => subjectIsFromThankYou.value,
};

export const isFromOrder = {
  subject: undefined,

  lazyInit() {
    if (isFromOrder.subject) return isFromOrder.subject;
    if (typeof window !== 'undefined') {
      const storage = window.localStorage;
      const isFromOrderNow = jsonStorage.get('isFromOrder', { storage }) || false;

      isFromOrder.subject = new BehaviorSubject(isFromOrderNow);
      return isFromOrder.subject;
    }
  },

  update: isEdit => {
    const isFromOrderSubject = isFromOrder.lazyInit();
    const storage = window.localStorage;
    jsonStorage.set('isFromOrder', isEdit, { storage });
    isFromOrderSubject.next(isEdit);
  },
  getValue: () => {
    const isEdit = isFromOrder.lazyInit();
    return isEdit?.value;
  },
};
